export default __webpack_public_path__ + "static/media/loading.01083c25.svg";